export var buildEnv = {
    buildMode: 'release',
    sdkVersion: '3.6.10',
};
//# sourceMappingURL=buildEnv.js.map